<template>
  <label class="flex cursor-pointer" :class="{'pointer-events-none': disabled}">
    <div class="relative mr-2">
      <input
        :key="inputKey"
        type="checkbox"
        class="HCheckbox hidden"
        :checked="modelValue || value || indeterminate"
        value="foo"
        @change="onChange"
      />
      <svg
        height="16"
        width="16"
        viewBox="0 0 24 24"
        class="hidden absolute fill-current pointer-events-none"
        :class="disabled ? 'text-gray-500' : 'text-white'"
      >
        <rect width="100%" height="100%" :fill="bgColor" />
        <line
          v-if="indeterminate"
          y1="11"
          x1="6"
          x2="18"
          y2="11"
          stroke="white"
          stroke-width="2"
        />
        <path v-else d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
      </svg>
      <div class="h-4 w-4 border border-gray-500" />
    </div>
    <span
      class="LmCheckBoxLabel select-none tracking-wider"
      :class="[
        color ? `text-${color}` : 'text-gray-500',
        formStyle ? 'self-center font-mono text-xxs uppercase' : 'leading-tight'
      ]"
      >{{ label }}</span
    >
  </label>
</template>

<script>
import tailwind from '@/lib/tailwindConfig'
export default {
  name: 'LmCheckbox',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: null
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    formStyle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputKey: 0
    }
  },
  computed: {
    bgColor() {
      if (this.disabled) return '#DCDCDC'
      return this.color ? tailwind.theme.colors[this.color] : '#171717'
    }
  },
  methods: {
    onChange(event) {
      this.$emit('change', event.target.checked)
      this.inputKey++
    }
  }
}
</script>

<style scoped>
.HCheckbox:checked + svg {
  display: block !important;
}
</style>
